import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  appointments: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
  popup: {
    show: false,
    item: {}
  },
}
export const appointmentsSlice = createSlice({
  name: 'appointments',
  initialState: initialState,
  reducers: {
    setAppointment: (state, { payload }) => {
      state.appointments = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setAppointments: (state, { payload }) => {
      state.appointments = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setMoreAppointments: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    removeAppointment: (state, { payload }) => {
      state.error = payload
    },
    clearAllAppointment: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
    setAddAppointmentPopup: (state, { payload }) => {
      state.popup = payload
    },
    closeAppointmentPopup: (state) => {
      state.popup.show = false;
      state.popup.item = {}
    }
  }
})

export const addAppointment = (data, callback, disableLoader) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  !disableLoader && dispatch(setLoader(true))
  try {

    const json = await Api.addAppointment(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setAppointment(json.data))
      callback(true, json.data.message, json?.data?.data)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  !disableLoader && dispatch(setLoader(true))
}

export const updateAppointment = (data, itemId, callback, disableLoader) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  !disableLoader && dispatch(setLoader(true))
  try {

    const json = await Api.updateAppointment(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setAppointment(json.data))
      callback(true, json.data.message, json?.data?.data)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
 !disableLoader && dispatch(setLoader(true))
}

export const removeAppointment = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeAppointment(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setAppointment(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const fetchAppointments = (page, params, disableLoader, Aync) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchAppointments(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          return result?.data?.data;
        }else{
          dispatch(setAppointments(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        }else{
          dispatch(setAppointments(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      }else{
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }
  } catch (error) {
    console.log("error", error)
  }
}

export const fetchAppointmentView = (id, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const result = await Api.fetchClientAppointmentView(id)
    // console.log("slicecall", result)
    if (result.status >= 200 && result.status < 300) {
      callback&&callback(true, result?.data?.message, result?.data?.data)
    } else if (result?.status == 422) {
      callback&&callback(false, result?.data?.message)
    }
  } catch (error) {
    // callback&&callback(false)
      callback&&callback(false, error?.data?.message)
  }
  dispatch(setLoader(false))
}


export const changeStatus = (id, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.statusChange(id, data, "subclients/appointments")
    if (json.status >= 200 && json.status < 300) {
      // console.log(json)
      // dispatch(setHospital(json.data))
      // callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      // callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeMultipleAppointments = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeMultipleAppointments(ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setHospital(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
};

export const filterPatient = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  try {

    const json = await Api.filterPatient(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setPatient(json.data))
      callback(true, json?.data?.data)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data?.errors)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
}

export const fetchAppointmentLogs = (id, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const result = await Api.fetchAppointmentLogs(id)
    if (result.status >= 200 && result.status < 300) {
      callback(true, result?.data?.message, result?.data?.data)
    } else if (result?.status == 422) {
      callback(false, result?.data?.message)
    }
  } catch (error) {
    // callback(false)
      callback(false, error?.data?.message)
  }
  dispatch(setLoader(false))
}


export const { 
  setAppointment, setAppointments,
  clearAllAppointment, setLoader, 
  setError, setMoreAppointments,
  setAddAppointmentPopup, closeAppointmentPopup

} = appointmentsSlice.actions


export default appointmentsSlice.reducer
export const appointmentsSelector = state => state.appointments


